export const LISTING_NOTE_TYPES = [
  "general",
  "quality",
  "dealer_followup",
  "duplicate",
  "outlier",
  "trust_safety",
  "import_issue",
];

export const LISTING_NOTE_TYPE_LABELS = {
  general: "General",
  quality: "Calidad",
  dealer_followup: "Seguimiento dealer",
  duplicate: "Duplicado",
  outlier: "Atípico",
  trust_safety: "Confianza",
  import_issue: "Importación",
};

export const DUPLICATE_STATUS_LABELS = {
  exact_stock_match: "Stock exacto",
  exact_url_match: "URL exacta",
  exact_plate_match: "Placa exacta",
  likely_duplicate: "Duplicado probable",
  possible_duplicate: "Posible duplicado",
};

export const OUTLIER_REASON_LABELS = {
  price_below_minimum: "Precio muy bajo",
  mileage_very_high: "Kilometraje muy alto",
  future_year: "Año futuro inválido",
  year_too_old: "Año muy antiguo",
  price_below_median: "Precio bajo vs mediana",
  price_above_median: "Precio alto vs mediana",
  mileage_low_for_age: "Km bajo para la edad",
};

export const ADMIN_LISTING_ACTIONS = [
  { action: "approve", label: "Aprobar" },
  { action: "needs_review", label: "Marcar revisión" },
  { action: "pause", label: "Pausar" },
  { action: "reactivate", label: "Reactivar" },
  { action: "reject", label: "Rechazar", needsReason: true },
  { action: "archive", label: "Archivar" },
  { action: "mark_sold", label: "Vendido" },
  { action: "confirm_available", label: "Confirmar disponible" },
];

export const BULK_LISTING_ACTIONS = [
  { action: "approve", label: "Aprobar/publicar" },
  { action: "needs_review", label: "Marcar revisión" },
  { action: "pause", label: "Pausar" },
  { action: "reactivate", label: "Reactivar" },
  { action: "archive", label: "Archivar" },
  { action: "confirm_available", label: "Confirmar disponible" },
  { action: "pending_confirmation", label: "Pendiente confirmación" },
];
